import { useEffect, useState } from 'react';
import { analysisQueue, type AnalysisQueueState } from '../lib/coaching/analysisQueue';

/** Expose l'état de la file d'analyse d'arrière-plan (cf. lib/coaching/analysisQueue.ts). */
export function useAnalysisQueue(): AnalysisQueueState {
  const [state, setState] = useState<AnalysisQueueState>(analysisQueue.getState());
  useEffect(() => analysisQueue.onStateChange(setState), []);
  return state;
}
